import { render } from "./ResponseQuotesView.vue?vue&type=template&id=5c1a7f06"
import script from "./ResponseQuotesView.vue?vue&type=script&lang=js"
export * from "./ResponseQuotesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__